export default class Accordion {
  constructor() {
    this.$els = document.querySelectorAll(".js-accordion");
    this.$els.forEach(($el) => {
      const $button = $el.querySelector(".js-accordion-button");
      const $content = $el.querySelector(".js-accordion-content");
      const $icon = $button.querySelector(".js-accordion-icon");

      $content.classList.add("hidden");
      $content.setAttribute("aria-expanded", false);

      $button.addEventListener("click", () => {
        $content.classList.toggle("hidden");
        $icon.classList.toggle("is-open");

        if ($content.classList.contains("hidden")) {
          $content.setAttribute("aria-expanded", false);
        } else {
          $content.setAttribute("aria-expanded", true);
        }
      });
    });
  }
}
